var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "Index ui form" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.config.state.processOutputWait,
              expression: "config.state.processOutputWait"
            }
          ],
          staticClass: "loading-modal"
        },
        [_c("img", { attrs: { src: _vm.loadingSVG } })]
      ),
      _vm._v(" "),
      _c("PanelMenu", {
        ref: "PanelMenu",
        attrs: { config: _vm.config, utils: _vm.utils }
      }),
      _vm._v(" "),
      _c("ConfigurationPanel", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.config.session.displayPanel === "configuration",
            expression: "config.session.displayPanel === 'configuration'"
          }
        ],
        ref: "ConfigurationPanel",
        attrs: { config: _vm.config, utils: _vm.utils }
      }),
      _vm._v(" "),
      _c("TextPanel", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.config.session.displayPanel === "text",
            expression: "config.session.displayPanel === 'text'"
          }
        ],
        ref: "TextPanel",
        attrs: { config: _vm.config, utils: _vm.utils }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }